import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { AcordoRedeEspecialViewModel } from './rede-especial.interface';
import { RedeEspecialService } from './rede-especial.service';

/**
 * Classe base para diálogos de ação em acordos (Aprovar, Recusar, Cancelar).
 * Centraliza lógica comum: lista de acordos, labels singular/plural, cancelar.
 */
export abstract class RedeEspecialAcordoDialogBase<T = unknown> {
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<T>,
    @Inject(MAT_DIALOG_DATA)
    public acordosSelecionados: AcordoRedeEspecialViewModel[],
    protected service: RedeEspecialService,
    protected snackBar: SnackBarService,
  ) {}

  onCancelar(): void {
    this.dialogRef.close(false);
  }

  /** Label "Acordo" ou "Acordos" conforme quantidade */
  get labelAcordo(): string {
    return this.acordosSelecionados?.length > 1 ? 'Acordos' : 'Acordo';
  }

  /** Código do acordo para exibição (codAcordo ou codAep ou codAdc) */
  codigoAcordo(acordo: AcordoRedeEspecialViewModel): number {
    return acordo.codAcordo ?? acordo.codAep ?? acordo.codAdc;
  }

  /** Mapeia acordos para o formato da lista (aprovar/recusar) */
  protected mapAcordosParaLista(): Array<{
    codAcordo: number;
    codSituacao: number;
    codAep: number;
    razaoSocialFrota: string;
  }> {
    return (this.acordosSelecionados ?? []).map((acordo) => ({
      codAcordo: acordo.codAcordo,
      codSituacao: acordo.codSituacao,
      codAep: acordo.codAep,
      razaoSocialFrota: acordo.razaoSocialFrota,
    }));
  }

  protected get usuarioLogin(): string {
    return this.service.usuario?.retorno?.login ?? 'usuario-desconhecido';
  }
}
